// project imports
import { AuthHeader, ApiUrl } from 'utils/Constants';

// ===============================|| User ||=============================== //

export const SetUserData = (data) => {
    const userData = {
        Id: data?.id,
        Name: data?.first_name + ' ' + data?.last_name,
        Image: data?.image,
        UserAdmin: data?.UserAdmin
    };
    localStorage.setItem('userData', JSON.stringify(userData));
    AuthHeader.Authorization = 'Bearer ' + localStorage.getItem('token');
};

export default SetUserData;

export const UserData = () => {
    return JSON.parse(localStorage.getItem('userData'));
};

export const Logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    AuthHeader.Authorization = '';
    location.href = '/';
};

export const CheckAuth = async () => {
    try {
        const res = await fetch(`${ApiUrl}/api/user/profile`, {
            method: 'GET',
            headers: AuthHeader
        });
        const response = await res.json();
        return response.success;
    } catch (error) {
        return false;
    }
};
